import axios from 'axios'
import api from '@/api'

const userForm = {
  state: {
    data: {}
  },
  getters: {
    getUserForm: state => state.data.data,
  },
  mutations: {
    USER_FORM_GET (state, payload) {
      state.data.data = payload
    },
    CLEAR_USER_FORM (state) {
      state.data = JSON.parse(JSON.stringify(state.data))
    }
  },
  actions: {
    userFormGet (context, data) {
      axios({
        method: 'post',
        url: `${api}/users/item/${data}`,
      }).then(response => {
        context.commit('CLEAR_USER_FORM');
        context.commit('USER_FORM_GET', response.data.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default userForm
